import React from 'react';
import AuthGuard from './components/guards/AuthGuard';
import async from './components/Async';
import Page401 from './pages/auth/Page401';
import Page404 from './pages/auth/Page404';

const Login = async(() => import('./pages/auth/Login'));
const ForgetPassword = async(() => import('./pages/auth/ForgetPassword'));
const Home = async(() => import('./pages/Home'));
const CleanList = async(() => import('./pages/admin/CleanList'));
const ContractorList = async(() => import('./pages/admin/ContractorList'));
const DailyList = async(() => import('./pages/contractor/DailyList'));
const WeeklyList = async(() => import('./pages/contractor/WeeklyList'));
const Account = async(() => import('./pages/Account'));
const CleanDetail = async(() => import('./pages/CleanDetail'));
const CompleteClean = async(() => import('./pages/contractor/CompleteClean'));
const ViewContractorCleans = async(() => import('./pages/admin/ViewContractorCleans'));
const NotReadyClean = async(() => import('./pages/contractor/NotReadyClean'));
const UploadImage = async(() => import('./pages/contractor/UploadImage'));
const SearchResult = async(() => import('./components/SearchResult'));

const routes = [
    {
        path: '/',
        element: (
            <AuthGuard>
                <Home />
            </AuthGuard>
        ),
        children: [
            {
                path: '/Cleans',
                element: <CleanList />
            },
            {
                path: '/Contractors',
                element: <ContractorList />
            },
            {
                path: '/Daily',
                element: <DailyList />
            },
            {
                path: '/Weekly',
                element: <WeeklyList />
            },
            {
                path: '/Account',
                element: <Account />
            },
            {
                path: '/CleanDetail',
                element: <CleanDetail />
            },
            {
                path: '/CompleteClean',
                element: <CompleteClean />
            },
            {
                path: '/NotReadyClean',
                element: <NotReadyClean />
            },
            {
                path: '/ViewContractorCleans',
                element: <ViewContractorCleans />
            },
            {
                path: '/UploadImage',
                element: <UploadImage />
            },
            {
                path: '/SearchResult',
                element: <SearchResult />
            }
        ]
    },
    {
        path: '/login',
        element: <Login />,
    },
    {
        path: '/ForgetPassword',
        element: <ForgetPassword />
    },
    {
        path: '/Page401',
        element: <Page401 />
    },
    {
        path: '*',
        element: <Page404 />
    },

]

export { routes };